import {init_map} from './map'
import {init_search_sliders} from './slider'

const history = require('html5-history-api');

function search_form() {
  const $form = $('.search-form form');
  const cache = {};
  let order = 'best';
  const change = () => {
    const query = $form.serialize() + '&order=' + order;
    if (cache[query]) {
      const data = cache[query];
      change_url(data);
      update_results(data);
    } else {
      const query_array = $form.serializeArray();
      const form_data = {};
      for (let input of query_array) {
        form_data[input.name] = input.value;
      }
      $.getJSON(`/search?${query}&ajax=1`, data => {
        const url = update_url(form_data, data);
        data.url = url;
        cache[query] = data;
        update_results(data);
      });
    }
  };
  $form.find(':input').on('change', () => {
    change();
  });
  $form.on('submit', () => {
    change();
    return false;
  });
  $('.search-form-mobile-popout').on('click', () => {
    $('.search-form').animate({'width': 'toggle'});
  });
  $('.search-form button.btn').on('click', () => {
    if ($(window).width() < 768) {
      $('.search-form').hide();
    }
  });
  $('.search-result-order').on('change', function() {
    order = $(this).val();
    change();
  });
}

function change_url(data) {
  const current_url = location.pathname + location.search;
  if (data.url != current_url) {
    history.pushState(data, null, data.url);
    document.title = data.title;
    update_results(data);
  }
}

function update_url(query, data) {
  let url = '/search/' + (query['q'].replace(/%20/g, '+') || '');
  delete query['q'];
  const params = [];
  for (let [name, value] of Object.entries(query)) {
    if (value !== '') {
      params.push(`${name}=${value}`);
    }
  }
  if (params.length > 0) {
    url += '?' + params.join('&');
  }
  data.url = url;
  change_url(data);
  return url;
}

function update_results(data) {
  $('.map').data('markers', data.map.markers);
  $('.search-result-num').text(`${data.num_results} Properties`);
  init_map($('.map'), null, true);
  $('.search-result-slider-track').each((_, track) => {
    if ($(track).hasClass('slick-slider')) {
      $(track).slick('unslick');
    }
  });
  const $result_template = $('.search-result-fluid .row > div').eq(0).clone();
  $result_template.css('display', '');
  $result_template.find('.search-result-slider-track').empty();
  $result_template.find('.search-result-properties tr').empty();
  $result_template.find('.search-result-properties tr').empty();
  const $results = $('.search-result-fluid .row');
  $results.show();
  console.log(data.results, data.results.length);
  if (!data.results[0].address) {
    $results.hide();
  } else {
    $results.empty();
    for (let result of data.results) {
      const $result = $result_template.clone();
      $result.find('.search-result-slider-track').append(
        $('<figure>', {
          class: 'aspect-ratio-8-6',
        }).html(
          $('<img>', {
            src: result.image,
            alt: result.description,
          })
        )
      );
      $result.find('.search-result-block').attr('href', result.url);
      $result.find('.search-result-title').text(result.address);
      $result.find('.search-result-place').text(result.place);
      $result.find('.search-result-price').text(result.price);
      $result.find('.search-result-description').text(result.description);
      const $thead = $result.find('.search-result-properties thead tr');
      const $tbody = $result.find('.search-result-properties tbody tr');
      for (let property of result.properties) {
        $thead.append(
          $('<th>', {
            scope: 'col',
            text: property.name,
          })
        );
        $tbody.append(
          $('<td>', {
            scope: 'row',
            text: property.value,
          })
        );
      }
      for (let image of result.images) {
        $result.find('.search-result-slider-track').append(
          $('<figure>', {
            'data-src': image.image,
            class: 'aspect-ratio-8-6',
          })
        );
      }
      $results.append($result);
    }
  }
  init_search_sliders();
  $('.pagination .page-item-dir:first .page-link').prop('href', data.prev_url);
  $('.pagination .page-item-dir:last .page-link').prop('href', data.next_url);
  const $page_item_template = $('.pagination :not(.page-item-dir)').eq(0).clone();
  $page_item_template.removeClass('active');
  $('.pagination :not(.page-item-dir)').remove();
  const $page_item_last = $('.pagination .page_item-dir:last');
  for (let page of data.pages) {
    const $page_item = $page_item_template.clone();
    $page_item.find('.page_link').text(page.number);
    if (page.active) {
      $page_item.addClass('active');
      $page_item.find('.page_link').append($('<span>', {class: 'sr-only', text: ' (current)'}));
    }
    $page_item_last.before($page_item);
  }
}

export function initalize() {
  search_form();
  $(window).on('popstate', e => {
    const data = e.originalEvent.state;
    if (!data) {
      location.href = location.href;
    } else {
      update_results(data);
    }
  });
}
